import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "icon"]
  static values = { spriteUrl: String }

  toggle() {
    const isPassword = this.inputTarget.type === "password"
    this.inputTarget.type = isPassword ? "text" : "password"
    this.iconTarget.querySelector("use").setAttribute("href", `${this.spriteUrlValue}#${isPassword ? "eye-off" : "eye"}`)
  }
}
